import { api } from '@xtnd/web/shared/api';
import { dateUtil, fileUtil } from '@xtnd/web/shared';
import queryString from 'query-string';

import { LedgerReportForm, MatterLedgerResponse } from '../types';

export class MatterLedgerService {
    private readonly baseResource = '/ar-collections/ledger';

    async getLedgerReport(queryParams: LedgerReportForm): Promise<MatterLedgerResponse> {
        const params: Record<string, any> = {
            reportType: queryParams.ledgerType,
            entityId: queryParams.ledgerData
        }

        const fromDate = queryParams.dateRange?.from ? dateUtil.formatDate(new Date(queryParams.dateRange.from), dateUtil.DateFormat.ISO) : undefined;
        const toDate = queryParams.dateRange?.to ? dateUtil.formatDate(new Date(queryParams.dateRange.to), dateUtil.DateFormat.ISO) : undefined;

        if (fromDate) {
            params.startDate = fromDate;
        }

        if (toDate) {
            params.endDate = toDate;
        }

        const query = queryString.stringify(params);
        const endpoint = `${this.baseResource}${query ? `?${query}` : ""}`;

        return await api.get<MatterLedgerResponse>(endpoint);
    }

    /**
      * Export collection queue
      */
    async exportCsv(queryParams: LedgerReportForm): Promise<any> {
        const params: Record<string, any> = {
            reportType: queryParams.ledgerType,
            entityId: queryParams.ledgerData
        }

        const fromDate = queryParams.dateRange?.from ? dateUtil.formatDate(new Date(queryParams.dateRange.from), dateUtil.DateFormat.ISO) : undefined;
        const toDate = queryParams.dateRange?.to ? dateUtil.formatDate(new Date(queryParams.dateRange.to), dateUtil.DateFormat.ISO) : undefined;

        if (fromDate) {
            params.startDate = fromDate;
        }

        if (toDate) {
            params.endDate = toDate;
        }
        const query = queryString.stringify(params);
        const endpoint = `${this.baseResource}/exportCsv${query ? `?${query}` : ''}`;

        const fileData = await api.get<Blob>(endpoint);

        const base64 = await fileData.text();

        await fileUtil.downloadBase64(
            base64,
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            `ar-ledger-report`
        );

        return 'success';
    }
}

export const reportingMatterLedgerApi = new MatterLedgerService();

